import { render, staticRenderFns } from "./ActMenontonVideo.vue?vue&type=template&id=1b7d5602&"
import script from "./ActMenontonVideo.vue?vue&type=script&lang=js&"
export * from "./ActMenontonVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports